import { render, staticRenderFns } from "./ModalTrackingGuideFiles.vue?vue&type=template&id=4a7bd274&lang=pug&"
import script from "./ModalTrackingGuideFiles.vue?vue&type=script&lang=js&"
export * from "./ModalTrackingGuideFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports